import { render, staticRenderFns } from "./DevicePrice.vue?vue&type=template&id=04d576df&scoped=true"
import script from "./DevicePrice.vue?vue&type=script&lang=ts"
export * from "./DevicePrice.vue?vue&type=script&lang=ts"
import style0 from "./DevicePrice.vue?vue&type=style&index=0&id=04d576df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d576df",
  null
  
)

export default component.exports